import React from 'react';
import { MarketplaceOrderEditViewStore } from 'modules/order/stores/wizard';
import { setCurrentView } from 'core/utils';
import { WizardContainerTemplate } from 'themes/modules/product/wizard/pages';

@setCurrentView(rootStore => new MarketplaceOrderEditViewStore(rootStore), 'marketplaceOrderEditViewStore')
class MarketplaceOrderEdit extends React.Component {
	render() {
		const {
			marketplaceOrderEditViewStore,
			marketplaceOrderEditViewStore: {
				form,
				isEdit,
				applyToAllActiveOrdersConfirmModal,
				loading,
			},
		} = this.props;
		return (
			<div>
				<WizardContainerTemplate
					viewStore={marketplaceOrderEditViewStore}
					itemName={isEdit ? 'MARKETPLACEORDEREDITFORM.TITLE.UPDATE' : 'MARKETPLACEORDEREDITFORM.TITLE.CREATE'}
					stepForm={form}
					applyToAllActiveOrdersConfirmModal={applyToAllActiveOrdersConfirmModal}
					disabled={loading}
					goBack={() => marketplaceOrderEditViewStore.rootStore.routerStore.goTo('master.app.main.order.marketplace.list')}
				/>
			</div>
		);
	}
}

export default MarketplaceOrderEdit;



// WEBPACK FOOTER //
// ./src/modules/order/pages/MarketplaceOrderEdit.jsx